import axios from 'axios';
import {start_loading,stop_loading} from '../loader/loaderAction'
import { TOKENS_UPDATE, USER_UPDATE } from './authTypes';
import {  toast } from 'react-toastify';
import apiClient from '../../api/apiClient';

const { REACT_APP_BASE_URL } = process.env;

const headers = {
  headers: {
    'Content-Type': 'application/json',
    'Accept':'application/json'
  },
};

export const set_update_user = (user,navigate) => {
  localStorage.setItem('auth',JSON.stringify(user));
  localStorage.setItem('token',user?.token);
  localStorage.setItem('refreshtoken',user?.refreshtoken);
  navigate('/');
  return {
    type: USER_UPDATE,
    payload: user,
  };
};


export const login_user = async (user, dispatch, navigate) => {
  dispatch(start_loading());
  try {
    const urlPath = `auth/login/admin`;

    const res = await apiClient.post(urlPath, user);

    if (res?.data?.data) {
      toast.success(res?.data?.message,{toastId: "Loginuser"});
      dispatch({ type: TOKENS_UPDATE, payload: res.data.data });
      dispatch(set_update_user(res?.data?.data,navigate));
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.log("Error:", error);
    toast(error?.response ? error?.response?.data?.message : error?.message);
  } finally {
    dispatch(stop_loading());
  }
};

export const get_login_user=()=>{
 let data= localStorage.getItem('auth')
 if(data){
  return data
 } else {return false};

}

export const admin_profile = async () => {
  try {
    const urlPath = `user/profile`;
    const response = await apiClient.get(urlPath);
    const userProfileData = response.data.data;

    const existingAuth = JSON.parse(localStorage.getItem('auth'));

    const updatedAuth = { ...existingAuth, ...userProfileData };

    localStorage.setItem('auth', JSON.stringify(updatedAuth));
    
    return userProfileData;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
